import React, { FC } from "react";
import Heading, { HeadingAlign, HeadingWeight } from "../components/Heading";
import { Button, ButtonSize } from "kaleidoscope/src";
import Text, { TextAlign, TextSize } from "../components/Text";
import { navigate } from "gatsby";

const Page404: FC = () => {
  return (
    <div className="page-404">
      <h1 className="page-404__title">404</h1>
      <div className="page-404__text">
        <Heading align={HeadingAlign.Center} weight={HeadingWeight.Strong} level={1} as="h2">
          Page not found
        </Heading>
        <Text className="page-404__description" size={TextSize.XLarge} align={TextAlign.Center}>
          The page you're looking for has either moved or doesn't exist.
        </Text>
        <Button
          size={ButtonSize.Large}
          onClick={() => {
            navigate("/");
          }}
        >
          Back to homepage
        </Button>
      </div>
    </div>
  );
};

export default Page404;
